export const formatDate = (date) => {
  if (!date) return "";

  const userOffset = new Date().getTimezoneOffset() * 60 * 1000; // смещение в миллисекундах
  const localDate = new Date(new Date(date).getTime() - userOffset); // корректируем исходную дату

  const optionsDate = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: false };

  const formattedDate = localDate.toLocaleDateString('ru-RU', optionsDate);
  const formattedTime = localDate.toLocaleTimeString('ru-RU', optionsTime);

  return `${formattedDate} ${formattedTime}`;
};


export const formatOrderString = (order, products, separator = ", ") => {

  const productDict = {};

  // Создаем словарь с id продукта в качестве ключа и объектом, содержащим описание и меру, как значением
  products.forEach(product => {
    productDict[product.id] = {
      shortDescription: product.short_description,
      measure: product.measure
    };
  });

  const parts = [];

  for (const productId in order) {
    const product = productDict[productId];
    if (product) {
      // Добавляем к строке короткое описание, количество заказа и меру
      parts.push(`${product.shortDescription} - ${order[productId]}${product.measure}`);
    }
  }

  return parts.join(separator);
}
